import { useEffect } from 'react'

// Text-like inputs only: checkboxes, radios and buttons keep their native
// Enter behaviour.
const NATIVE_ENTER_TYPES = ['checkbox', 'radio', 'button', 'submit', 'file']

const FOCUSABLE_SELECTOR =
	'input:not([type=hidden]):not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), [tabindex]:not([tabindex="-1"])'

const isDecorativeControl = el =>
	el.classList.contains('field-clear-btn') || el.classList.contains('selected-flag')

// Pressing Enter in a text input moves to the next field of the current
// section card (there is no <form> to submit). Returns true when it moved the
// focus, so callers and tests can tell.
export const advanceFocusOnEnter = event => {
	if (event.key !== 'Enter') return false
	// Enter that confirms an IME composition, or that another handler already
	// consumed, or that carries a modifier, is not ours.
	if (event.isComposing || event.defaultPrevented) return false
	if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return false

	const target = event.target
	if (target.tagName !== 'INPUT') return false
	if (NATIVE_ENTER_TYPES.includes(target.type)) return false
	// Enter selects the highlighted option in comboboxes / autocompletes.
	if (target.getAttribute('role') === 'combobox' || target.hasAttribute('aria-autocomplete'))
		return false
	if (target.closest('[role=listbox], [role=combobox]')) return false

	const card = target.closest('.section-card')
	if (!card) return false

	const focusable = Array.from(card.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
		el => el.offsetParent !== null && !isDecorativeControl(el)
	)
	const index = focusable.indexOf(target)
	if (index === -1 || index === focusable.length - 1) return false

	event.preventDefault()
	focusable[index + 1].focus()
	return true
}

export const useEnterAdvancesFocus = () => {
	useEffect(() => {
		document.addEventListener('keydown', advanceFocusOnEnter)
		return () => document.removeEventListener('keydown', advanceFocusOnEnter)
	}, [])
}
